import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")

  return (_openBlock(), _createBlock(_component_a_select, {
    "show-search": "",
    value: _ctx.roleId,
    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roleId = $event)),
    placeholder: "请选择商户",
    style: {"width":"200px"},
    "default-active-first-option": false,
    "show-arrow": false,
    "filter-option": false,
    "not-found-content": null,
    onSearch: _ctx.handleSearch,
    onChange: _ctx.handleChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (d) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: d.corpId
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(d.name), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "onSearch", "onChange"]))
}